module.exports = __webpack_public_path__ + "static/media/18.a4434c5b.jpg";